import { useMemo } from 'react';
import { usePublicClient } from 'wagmi';
import { providers } from 'ethers';
import type { PublicClient } from 'viem';

// Convert a viem PublicClient to an ethers.js Provider
function publicClientToProvider(publicClient: PublicClient) {
  const { chain, transport } = publicClient;
  const network = {
    chainId: chain?.id ?? 1,
    name: chain?.name ?? 'mainnet',
    ensAddress: chain?.contracts?.ensRegistry?.address,
  };
  if (transport.type === 'fallback') {
    return new providers.FallbackProvider(
      (transport.transports as { value: { url: string } }[]).map(
        ({ value }) => new providers.JsonRpcProvider(value?.url, network),
      ),
    );
  }
  return new providers.JsonRpcProvider(transport.url, network);
}

// Hook to get an ethers.js Provider from wagmi
export function useEthersProvider() {
  const publicClient = usePublicClient();

  return useMemo(
    () => publicClientToProvider(publicClient),
    [publicClient],
  );
}
